

let util = {}

// scrollTop animation
util.scrollTop = (el, from = 0, to, duration = 500, endCallback) => {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = (
      window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function (callback) {
              return window.setTimeout(callback, 1000 / 60)
            }
    )
  }
  const difference = Math.abs(from - to)
  const step = Math.ceil(difference / duration * 50)

  const scroll = (start, end, step) => {
    if (start === end) {
      endCallback && endCallback()
      return
    }

    let d = (start + step > end) ? end : start + step
    if (start > end) {
      d = (start - step < end) ? end : start - step
    }

    if (el === window) {
      window.scrollTo(d, d)
    } else {
      el.scrollTop = d
    }
    window.requestAnimationFrame(() => scroll(d, end, step))
  }
  scroll(from, to, step)
}
/**
 * @description 绑定事件 on(element, event, handler)
 */
util.on = (function () {
  if (document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler)
      }
    }
  }
})()

/**
 * @description 解绑事件 off(element, event, handler)
 */
util.off = (function () {
  if (document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler)
      }
    }
  }
})()

util.deepObject = function (source, target) {
  for (let k in source) {
    if (source.hasOwnProperty(k)) {
      if (source[k] && typeof source[k] == 'object') {
        if (!target[k]) { target[k] = source[k].constructor === Array ? [] : {} }
        target[k] = util.deepObject(source[k], target[k])
      } else if (!target[k]) { target[k] = source[k] }
    }
  }
  return target	
}
util.cloneObject = function (source, target) {
  for (let k in source) {
    if (source.hasOwnProperty(k) && target.hasOwnProperty(k)) {
      target[k] = source[k]
    }
  }
  // console.log('cloneObject', target);
  return target
}
export default util



// WEBPACK FOOTER //
// ./src/libs/util.js